import { Component } from '@angular/core';
import { ContextService } from 'projects/cross-study-portal-lib/src/public-api';
import { LogoutService } from '../../services/api-services/logout.service';

@Component({
  selector: 'mcp-logout',
  templateUrl: './logout.component.html',
})
export class LogoutComponent {
  constructor(private logoutService: LogoutService, private context: ContextService, private window: Window) { }

  logout(): void {
    this.logoutService.logout().subscribe(() => {
      if (this.context.instance != null) {
        this.window.location.href = this.context.instance.logoutUrl;
      }
    });
  }
}
